export default __webpack_public_path__ + "static/media/roadmap.3a357fd4.png";